import { Menu, useTheme } from '@mui/material';

interface RoundedMenuProps {
  anchorEl: HTMLElement;
  anchorOrigin: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'right';
  };
  transformOrigin: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'right';
  };
  width?: string;
  open: boolean;
  isPadded?: boolean;
  handleClose: () => void;
  children: React.ReactNode;
}

export const RoundedMenu = ({
  anchorEl,
  anchorOrigin,
  transformOrigin,
  width,
  open,
  isPadded = true,
  handleClose,
  children,
}: RoundedMenuProps) => {
  const theme = useTheme();

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      sx={{
        '& .MuiPaper-root': {
          padding: isPadded ? '24px' : '0',
          borderRadius: theme.app.borderRadius.moreRounded,
          width: width || 'auto',
        },
      }}
    >
      {children}
    </Menu>
  );
};
